const initLussoNavigation = (navigation) => {
  if (!navigation || navigation.dataset.initialized === 'true') return;

  const menuButton = navigation.querySelector('.le-menu-trigger');
  const closeButton = navigation.querySelector('.le-drawer-close');
  const drawer = navigation.querySelector('.le-menu-drawer');
  const scrim = navigation.querySelector('.le-drawer-scrim');
  const menuStage = navigation.querySelector('[data-le-menu-stage]');

  if (!menuButton || !closeButton || !drawer || !scrim) return;

  const menuPanels = menuStage ? Array.from(menuStage.querySelectorAll('[data-le-menu-panel]')) : [];
  const rootPanel = menuPanels.find((panel) => panel.dataset.menuLevel === '1');

  if (menuStage) {
    menuPanels.forEach((panel) => {
      if (panel.parentElement !== menuStage) menuStage.appendChild(panel);
    });
  }

  const findPanel = (panelId) => {
    const panel = panelId ? document.getElementById(panelId) : null;
    return panel && navigation.contains(panel) ? panel : null;
  };

  const showPanel = (targetPanel, focusControl = true) => {
    if (!targetPanel || !menuStage) return;

    menuPanels.forEach((panel) => {
      const isActive = panel === targetPanel;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', String(!isActive));
    });

    drawer.querySelectorAll('[data-le-menu-next]').forEach((control) => {
      control.setAttribute('aria-expanded', String(control.getAttribute('aria-controls') === targetPanel.id));
    });

    drawer.classList.toggle('is-submenu-open', targetPanel !== rootPanel);

    if (focusControl) {
      const focusTarget = targetPanel.querySelector('[data-le-menu-back], .le-menu-row, .le-menu-view-all');
      if (focusTarget) window.requestAnimationFrame(() => focusTarget.focus());
    }
  };

  const resetPanels = () => {
    if (rootPanel) showPanel(rootPanel, false);
  };

  const setMenu = (open, restoreFocus = true) => {
    drawer.classList.toggle('is-open', open);
    scrim.classList.toggle('is-open', open);
    document.body.classList.toggle('is-le-menu-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    menuButton.setAttribute('aria-expanded', String(open));

    if (open) {
      resetPanels();
      closeButton.focus();
    } else {
      resetPanels();
      if (restoreFocus) menuButton.focus();
    }
  };

  menuButton.addEventListener('click', () => setMenu(true));
  closeButton.addEventListener('click', () => setMenu(false));
  scrim.addEventListener('click', () => setMenu(false));
  drawer.querySelectorAll('[data-le-menu-next]').forEach((control) => {
    control.addEventListener('click', (event) => {
      event.preventDefault();
      const targetPanel = findPanel(control.getAttribute('aria-controls'));
      showPanel(targetPanel);
    });
  });

  drawer.querySelectorAll('[data-le-menu-back]').forEach((control) => {
    control.addEventListener('click', () => {
      const currentPanel = control.closest('[data-le-menu-panel]');
      const parentPanel = currentPanel?.dataset.parentPanel
        ? findPanel(currentPanel.dataset.parentPanel)
        : rootPanel;
      const returnControl = currentPanel
        ? Array.from(drawer.querySelectorAll('[data-le-menu-next]')).find(
            (item) => item.getAttribute('aria-controls') === currentPanel.id
          )
        : null;

      showPanel(parentPanel, false);
      if (returnControl) window.requestAnimationFrame(() => returnControl.focus());
    });
  });

  drawer.querySelectorAll('a:not([data-le-menu-next])').forEach((link) =>
    link.addEventListener('click', () => setMenu(false, false))
  );

  navigation.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) setMenu(false);
  });

  navigation.dataset.initialized = 'true';
};

const initLussoSlide = (slide) => {
  if (!slide || slide.dataset.initialized === 'true') return;

  const videoToggle = slide.querySelector('[data-le-video-toggle]');
  if (videoToggle) {
    videoToggle.addEventListener('click', () => {
      const videos = Array.from(slide.querySelectorAll('.le-slide__video')).filter(
        (video) => window.getComputedStyle(video).display !== 'none'
      );
      const shouldPause = videos.some((video) => !video.paused);

      videos.forEach((video) => {
        if (shouldPause) video.pause();
        else video.play().catch(() => {});
      });

      videoToggle.setAttribute('aria-label', shouldPause ? 'Play video' : 'Pause video');
      videoToggle.querySelector('span').textContent = shouldPause ? '▶' : 'Ⅱ';
    });
  }

  slide.dataset.initialized = 'true';
};

const initLussoEditableTheme = (root = document) => {
  root.querySelectorAll('[data-le-navigation]').forEach(initLussoNavigation);
  root.querySelectorAll('[data-le-slide]').forEach(initLussoSlide);
};

initLussoEditableTheme();

document.addEventListener('shopify:section:load', (event) => {
  initLussoEditableTheme(event.target);
});

document.addEventListener('shopify:section:unload', () => {
  document.body.classList.remove('is-le-menu-open');
});
